module.exports = __webpack_public_path__ + "static/media/doctor_eisenbarth__traveling_physician.75d58404.png";